module.exports = __webpack_public_path__ + "img/p2pMarketData.59f37fa6.png";